import { FaArrowCircleDown, FaArrowCircleUp, FaFileUpload } from "react-icons/fa";
import { AiOutlineArrowUp, AiOutlineDelete } from "react-icons/ai";
import { getApp, initializeApp } from "firebase/app";
import { getDownloadURL, getMetadata, getStorage,ref, uploadBytes, uploadBytesResumable } from "firebase/storage";
import { useEffect, useState } from "react";
import { doc, getDoc, getFirestore, onSnapshot, setDoc } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDvyFE51u8HLshOA9RPHIX49CqSpT62VU4",
    authDomain: "funnel-887b0.firebaseapp.com",
    databaseURL: "https://funnel-887b0.firebaseio.com",
    projectId: "funnel-887b0",
    storageBucket: "funnel-887b0.appspot.com",
    messagingSenderId: "948800714095",
    appId: "1:948800714095:web:289b59b34a9aec463ba49a",
    measurementId: "G-0TG7HL2T80"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore();
const storage = getStorage();
const imagesRef = ref(storage, 'banner.png');

export default function BannerImage(props){

    const [bannerUrl,setBannerUrl]= useState([]);

    useEffect(async() => {
        console.log("setting images");
        const unsub = onSnapshot(doc(db,"appSettings","images"), (doc) => {
            var data=doc.data();
            setBannerUrl(data["banner"]);
        });
          
    }, []);

    return(
        <div className="bg-white/10 border-white/50 shadow-xl  border-1 rounded h-96 w-full flex justify-center items-center flex-row">
           
            <div className="border-none w-1/4 flex justify-center items-center">

                <button 
                onClick={()=>{
                    var input = document.createElement('input');
                    input.type = 'file';
                    input.click();
                    input.onchange =   async (e) => { 
                        var file = e.target.files[0];
                        const uploadTask = uploadBytesResumable(imagesRef, file);
                        uploadTask.on("state_changed",(snapshot)=>{
                            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                            console.log('Upload is ' + progress + '% done');
                        },
                        ()=>{},
                        ()=>{
                            getDownloadURL(uploadTask.snapshot.ref).then(async (url)=>{
                                console.log(url);
                                bannerUrl.push(url);
                                await setDoc(doc(db,"appSettings","images"),{"banner":bannerUrl},{merge:true});
                                
                            })
                        }
                        )
                        
                        console.log("uploading a file");

                     }

                   
                }}
                 
                className="flex justify-center items-center">
                    <FaFileUpload size={100} className=""/>
                </button>

            </div>




            <div className="flex flex-col h-full w-full overflow-scroll">
                {
                    bannerUrl.map((element,imageIndex)=>{
                        return(

                        <div className="flex flex-row">
                            <div style={{
                                backgroundImage:`url(${element})`,
                                backgroundPosition:"center",
                                }} 
                                className="bg-white/10 w-3/4 h-48 flex justify-center items-center bg-contain bg-no-repeat">
                            </div>

                            <div className="flex flex-col justify-center items-center pl-5">
                            <FaArrowCircleUp
                                onClick={async ()=>{
                                    var data= (await getDoc(doc(db,"appSettings","images"))).data();
                                    var bannerUrl=data["banner"];
                                    var previous=bannerUrl[imageIndex-1];
                                    var current=bannerUrl[imageIndex];

                                    if(imageIndex!=0){
                                        bannerUrl[imageIndex-1]=current;
                                        bannerUrl[imageIndex]=previous;
                                        await setDoc(doc(db,"appSettings","images"),{"banner":bannerUrl},{merge:true});    
                                        console.log("banner list is"+bannerUrl);
                                    }

                                }}
                                className="mb-4 hover:scale-110 " color="white" size={40} />


                                <FaArrowCircleDown
                                 onClick={async ()=>{
                                    var data= (await getDoc(doc(db,"appSettings","images"))).data();
                                    var bannerUrl=data["banner"];
                                    var future=bannerUrl[imageIndex+1];
                                    var current=bannerUrl[imageIndex];

                                    if(imageIndex!=(bannerUrl.length-1)){
                                           bannerUrl[imageIndex+1]=current;
                                        bannerUrl[imageIndex]=future;
                                        await setDoc(doc(db,"appSettings","images"),{"banner":bannerUrl},{merge:true});    
                                        console.log("banner list is"+bannerUrl);
                                    }

                                }}
                                className="mb-4 hover:scale-110" 
                                color="white" size={40} />

                            </div>

                            <button
                                onClick={async()=>{
                                    var data= (await getDoc(doc(db,"appSettings","images"))).data();
                                    var bannerList=data["banner"];
                                    bannerList.splice(imageIndex,1);
                                    await setDoc(doc(db,"appSettings","images"),{"banner":bannerList},{merge:true});    
                                    console.log("banner list is"+bannerList);
                                }}
                                className=" ml-5 rounded hover:scale-105 hover:bg-red-500 flex justify-center items-center">
                                    <AiOutlineDelete size={30}/>
                            </button> 


                        </div>
                        
                        )
                    })
                }
            </div>


        </div>
    )
}